import {ref} from "vue";

export const useGetGoods = () => {
    const items = ref(null);

    const getGoods = async (updateShipmentId) => {
        let url = '/shipments/goods/' + updateShipmentId;

        return await axios.get(url).then(({data}) => {
            items.value = data;
            return data;
        });
    }

    return { getGoods, items };
}
